export default () => (next) => (action) => {
  if (action.payload && action.payload.redirectUrl) {
    window.location = action.payload.redirectUrl;
    return;
  }
  next(action);
};
